<template>
    <div id="registered-owner-color-action-legend" class="pt-2">
        <p class="py-1 text-left text-lg font-bold ">{{ this.$t('Template.ColorLegend.Label') }}</p>
        <div id="action-legend" class="flex-row-container">
            <div class="flex-row-item">
                <div class="add action-color inline-grid"></div>
                <p class="text-label">{{ this.$t('Template.ColorLegend.AddOwner') }}</p>
            </div>
            <div class="flex-row-item">
                <div class="edit action-color inline-grid"></div>
                <p class="text-label">{{ this.$t('Template.ColorLegend.EditOwner') }}</p>
            </div>
            <div class="flex-row-item">
                <div class="remove action-color inline-grid"></div>
                <p class="text-label">{{ this.$t('Template.ColorLegend.RemoveOwner') }}</p>
            </div>
            <div class="flex-row-item">
                <div class="missing-data action-color inline-grid"></div>
                <p class="text-label">{{ this.$t('Template.ColorLegend.MissingData') }}</p>
            </div>
        </div>
    </div>
</template>

<style>

    #action-legend {
        border: .1rem solid lightgray;
        width: 40%;
    }

    #action-legend .action-color {
        width: 2rem;
        height: 2rem;
    }

    #action-legend .add {
        background-color: rgb(222,248,232);
    }

    #action-legend .edit {
        background-color: rgb(254,240,228);
    }

    #action-legend .remove {
        background-color: rgba(255,244,214);
    }

    #action-legend .missing-data {
        background-color: rgb(254,233,233);
    }

    .flex-row-container {
        display: flex;
        flex-wrap: wrap;
    }

    .flex-row-container > .flex-row-item {
        flex: 1 1 auto;
        padding: .4rem;
        text-align: center;
    }

    .text-label {
        font-size: 1rem;
        margin-top: .2rem;
    }

    p {
        line-height: 1.8em !important;
    }

</style>
